"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _AddToCartDialogAlertView = _interopRequireDefault(require("./AddToCartDialogAlertView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function AddToCartDialogView(props) {
  var open = props.open,
    numberOfFilesSelected = props.numberOfFilesSelected,
    onYesClick = props.onYesClick,
    onNoClick = props.onNoClick,
    _props$cartWillFull = props.cartWillFull,
    cartWillFull = _props$cartWillFull === void 0 ? false : _props$cartWillFull,
    alertMessage = props.alertMessage;
  if (cartWillFull) {
    return /*#__PURE__*/_react.default.createElement(_AddToCartDialogAlertView.default, {
      alertMessage: alertMessage,
      open: open,
      onClose: function onClose() {
        return onNoClick();
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: open,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.DialogContentText, {
    id: "alert-dialog-description"
  }, "Are you sure to add All Files", ' ', numberOfFilesSelected, ' ', "to cart")), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "yesBtn",
    onClick: function onClick() {
      return onYesClick();
    }
  }, "Yes"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "noBtn",
    onClick: function onClick() {
      return onNoClick();
    }
  }, "No"))));
}
var _default = AddToCartDialogView;
exports.default = _default;